<template>
    <div class="h-full w-full max-w-xl md:max-w-none">
        <div class="h-full block flex items-center justify-center px-6 cursor-pointer text-xl w-full md:w-auto">
            <div @click.self="openLocationSearch"
                class="flex flex-col md:flex-row items-center border border-gray-300 rounded-xl md:rounded-full w-full md:w-auto bg-white dark:bg-neutral-700 dark:text-white shadow-xl dark:border-neutral-900 justify-between px-2 md:pl-0 md:pr-3 py-2 md:py-0 animate-in zoom-in duration-300 ease-in-out">
                <div class="flex flex-col md:flex-row md:justify-center md:items-center group w-full">
                    <div @click.self="openLocationSearch"
                        class="truncate md:hover:scale-95 md:hover:bg-gray-100 dark:md:hover:bg-neutral-500 transition duration-300 grow-0 shrink flex md:flex-col gap-1 w-full h-20 md:h-auto justify-between items-center md:items-start md:justify-start md:w-[200px] md:max-w-[30vw] py-4 px-4 md:pl-10 md:pr-8 rounded-full cursor-pointer">
                        <span class="text-base md:text-sm font-semibold pointer-events-none">{{ listingType }}</span>
                        <span
                            class="truncate max-w-full text-base md:text-sm text-right md:text-left pointer-events-none pl-2 md:pl-0">
                            {{ listing_type_description ?? $t('Search locations') }}
                        </span>
                    </div>
                    <div
                        class="hidden md:block h-full min-h-[1.5em] w-[2px] bg-gray-300 dark:bg-neutral-800 my-2 group-hover:bg-transparent transition duration-300 rounded-full">
                    </div>
                    <div id="calendarbutton" @click="openCalendarSearch()"
                        class="px-4 md:px-8 md:hover:scale-95 md:hover:bg-gray-100 dark:md:hover:bg-neutral-500 transition duration-300 hidden grow shrink-0 md:flex flex-col gap-1 py-4 active:scale-75 rounded-full cursor-pointer">
                        <span class="text-base md:text-sm font-semibold">{{ $t('Check-in') }}</span>
                        <span class="text-base md:text-sm">{{ checkin ?? $t('Select dates') }}</span>
                    </div>
                    <div
                        class="hidden md:block h-full min-h-[1.5em] w-[2px] bg-gray-300 dark:bg-neutral-800  my-2 group-hover:bg-transparent transition duration-300 rounded-full">
                    </div>
                    <div id="calendar2button" @click="openCalendarSearch()"
                        class="px-4 md:px-8 md:hover:scale-95 md:hover:bg-gray-100 dark:md:hover:bg-neutral-500 transition duration-300 hidden grow shrink-0 md:flex flex-col gap-1 py-4 hover:bg-gray-100 active:scale-75 rounded-full cursor-pointer">
                        <span class="text-base md:text-sm font-semibold">{{ $t('Check-out') }}</span>
                        <span class="text-base md:text-sm">{{ checkout ?? $t('Select dates') }}</span>
                    </div>
                    <div id="calendar2button" @click="openCalendarSearch()"
                        class="px-4 md:hidden grow shrink-0 flex w-full h-20 md:h-auto justify-between items-center md:items-start md:justify-start md:flex-col gap-1 py-4 hover:bg-gray-100 dark:hover:bg-neutral-700 active:scale-75 rounded-full cursor-pointer">
                        <span class="text-base md:text-sm font-semibold hidden xs:block">{{ $t('Check-in') }}/{{
                            $t('Check-out')
                        }}</span>
                        <span class="text-base md:text-sm font-semibold xs:hidden">{{ $t('Dates') }}</span>
                        <span class="text-base md:text-sm text-right">
                            {{ checkin && checkout ? checkin + " - " + checkout : $t('Select dates') }}
                        </span>
                    </div>

                    <template v-if="useguests">
                        <div
                            class="hidden md:block h-full min-h-[1.5em] w-[2px] bg-gray-300 dark:bg-neutral-800  my-2 group-hover:bg-transparent transition duration-300 rounded-full">
                        </div>
                        <div id="calendarbutton" @click="openGuestsSearch"
                            class="px-4 md:hover:scale-95 md:hover:bg-gray-100 dark:md:hover:bg-neutral-500 active:scale-75 transition duration-300 md:px-8 grow shrink-0 mb-2 md:mb-0 flex md:flex-col w-full md:w-auto h-20 md:h-auto justify-between items-center md:items-start md:justify-start  md:flex-col gap-1 py-4 hover:bg-gray-100 dark:hover:bg-neutral-700 rounded-full cursor-pointer">
                            <span class="text-base md:text-sm font-semibold">{{ $t('Guests') }}</span>
                            <span class="text-base md:text-sm text-right md:text-left">
                                {{ numadult ? parseInt(numadult) + parseInt(numchildren) : $t('Select guests') }}
                            </span>
                        </div>
                    </template>
                </div>
                <button @click="performSearch"
                    class="bg-primary w-full rounded-lg md:rounded-full text-white h-14 md:w-14 shrink-0 flex justify-center items-center cursor-pointer px-2 md:px-0  md:hover:scale-95 transition duration-300 active:bg-primary-dark active:!scale-75">
                    <span class="md:hidden pr-2 text-base md:text-sm">{{ $t('Search') }}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="currentColor"
                        viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
                        <path
                            d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>
  
<script>
import VueCookies from 'vue-cookies'
import moment from "moment";

export default {
    data() {
        return {
            location: null,
            locationName: null,
            checkin: null,
            checkout: null,
            numadult: 2,
            numchildren: 0,
            listingType: null,
            listing_type_description: null,
            useguests: false,
        };
    },
    methods: {
        openLocationSearch(e) {
            if (e.target.id != "calendarbutton") {
                this.$root.$emit("showLocationSearch", true);
            }
        },
        openCalendarSearch() {
            this.$root.$emit("showCalendarSearch", true);
        },
        openGuestsSearch() {
            this.$root.$emit("showGuestsSearch", true);
        },
        performSearch() {
            var url = this.$homeUrl + '/accomodations/?numAdult=' + parseInt(VueCookies.get('numAdult')) + '&numChildren=' + parseInt(VueCookies.get('numChildren'));

            if (VueCookies.get('checkin')) {
                url = url + '&checkin=' + moment(VueCookies.get('checkin')).format('YYYYMMDD')
            }
            if (VueCookies.get('checkout')) {
                url = url + '&checkout=' + moment(VueCookies.get('checkout')).format('YYYYMMDD')
            }
            if (VueCookies.get('searchlocation')) {
                var location = VueCookies.get('searchlocation');
                if (location.hasOwnProperty('nonHome')) {
                    url = url + '&' + encodeURIComponent(location.nonHome) + '=' + encodeURIComponent(location.name);
                } else {
                    url = url + '&name=' + encodeURIComponent(location.name);
                }
            }

            window.location.href = url;
        }
    },

    mounted() {


        const clientVars = this.$attrs.clientvariables ? JSON.parse(this.$attrs.clientvariables) : {};

        this.listingType = clientVars['listing_type'];
        this.listing_type_description = clientVars['listing_type_description'];
        this.useguests = clientVars.useguests == "1" ? true : false;

        this.$root.$on("locationChange", (msg) => {
            this.location = VueCookies.get('searchlocation');
            this.locationName = VueCookies.get('searchlocation').name;
        });
        this.$root.$on("checkinSelect", (msg) => {
            this.checkin = moment(VueCookies.get('checkin')).format('Do MMM');
        });
        this.$root.$on("checkoutSelect", (msg) => {
            this.checkout = moment(VueCookies.get('checkout')).format('Do MMM');
        });
        this.$root.$on("numAdult", (msg) => {
            this.numadult = VueCookies.get('numAdult');
        });
        this.$root.$on("numChildren", (msg) => {
            this.numchildren = VueCookies.get('numChildren');
        });
    },

    filters: {
        smallDate: function (date) {
            return moment(date).format('Do MMM');
        }
    },

    created() {
        moment.locale(document.documentElement.lang);
        this.currentUrl = this.$attrs.base_url;

        if (VueCookies.get('searchlocation')) {
            this.location = VueCookies.get('searchlocation')
            this.locationName = VueCookies.get('searchlocation').name;
        }

        if (VueCookies.get('checkin')) {
            this.checkin = moment(VueCookies.get('checkin')).format('Do MMM');
        }

        if (VueCookies.get('checkout')) {
            this.checkout = moment(VueCookies.get('checkout')).format('Do MMM');
        }

        if (VueCookies.get('numAdult')) {
            this.numadult = VueCookies.get('numAdult');
        }

        if (VueCookies.get('numChlldren')) {
            this.numchildren = VueCookies.get('numChildren');
        }
    },
};
</script>
  